import {Component, Input, OnInit} from '@angular/core';
import {EnumCardLayoutHeaderIcon} from '@lv1871/core';

@Component({
    selector: 'lv-uiartefakt-container-header',
    templateUrl: './uiartefakt-container-header.component.html',
    styleUrls: ['./uiartefakt-container-header.component.scss'],
    standalone: false
})
export class UIArtefaktContainerHeaderComponent implements OnInit {

  @Input()
  public text: string;

  @Input()
  public titel: string;

  @Input()
  public cardLayout: string;

  public cardIcon: string;
  constructor() { }

  ngOnInit(): void {
    this.cardIcon = EnumCardLayoutHeaderIcon[this.cardLayout];
  }
}
